// extracted by mini-css-extract-plugin
module.exports = {"item":"item--TfFfz","iconWrap":"iconWrap--25e25","iconUp":"iconUp--1cUT3","iconDown":"iconDown--3o-q7","title":"title--1DaKM","describe":"describe--AA0-D"};